import { Controller } from "@hotwired/stimulus";

declare global {
  interface Window { ChangeTarget: MessagePort}
}

export default class extends Controller {
  static targets = [
    "overlay", "changeDeliveryTypeForm", "deliveryOverlay",
    "searchBarOverlay", "searchBarInput",
    "unavailableOverlay", "menuButtonTarget"
  ];

  declare overlayTarget : HTMLElement;
  declare deliveryOverlayTarget: HTMLElement;
  declare searchBarOverlayTarget: HTMLElement;
  declare searchBarInputTarget: HTMLInputElement;
  declare changeDeliveryTypeFormTarget : HTMLFormElement;
  declare unavailableOverlayTarget : HTMLElement;
  declare menuButtonTarget: HTMLElement;

  declare hasOverlayTarget: boolean;

  menuButtonTargetConnected(target: HTMLElement) {
    target.ariaDisabled = "false";
  }

  changeDeliveryType() {
    this.changeDeliveryTypeFormTarget.submit();
  }

  openNav(event: Event): void {
    event.stopPropagation();
    this.overlayTarget.classList.add("is-active");
  }

  closeNav() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("is-active");
    }
  }

  supressClose(event: Event) {
    event.stopPropagation();
  }

  openDeliveryDetails() {
    this.deliveryOverlayTarget.classList.add("is-active");
  }

  openUnavailableModal(event: Event) {
    event.stopPropagation();
    this.unavailableOverlayTarget.classList.add("is-active");
  }

  closeUnavailableModal() {
    this.unavailableOverlayTarget.classList.remove("is-active");
  }

  closeDeliveryDetails() {
    this.deliveryOverlayTarget.classList.remove("is-active");
  }

  openSearchBar() {
    this.searchBarOverlayTarget.classList.add("is-active");
  }

  closeAll(event: KeyboardEvent) {
    if (event.key != "Escape") {
      return;
    }

    if (this.hasOverlayTarget) {
      this.closeNav();
    }
  }

  // Used by the customer app to help change environments
  changeTarget() {
    if (window.ChangeTarget !== undefined) {
      window.ChangeTarget.postMessage('ChangeTarget');
    }
  }
}
